import { MarketboardDict } from '../../contracts/dict/IMarketboard';

export const marketBoardDict: MarketboardDict = {
    onLoadEventErrorTitle: 'Something went wrong',
    onLoadEventErrorText: 'Try refreshing the page.',
    MiddleTermAt: 'at',
    MiddleTermVs: 'vs'
};
